import Prism from 'prismjs';
Prism.manual = false;

const forum = document.getElementById('af-wrapper');

if (forum) {
    Prism.highlightAllUnder(document.getElementById('af-wrapper'));
}